import { Flex, FormLabel, Switch } from '@chakra-ui/react'
import type { AppInfoMessageFilter } from 'BrokerTsLib/src/dtos'
import { FormProvider, useForm } from 'BrokerTsLib/src/rhf'
import { useEffect } from 'react'

export const NewsFilter = ({ filter, onSubmit }: {
  filter: AppInfoMessageFilter
  onSubmit: (filter: AppInfoMessageFilter) => void
}) => {
  const methods = useForm<AppInfoMessageFilter>({ defaultValues: filter })
  const { register, handleSubmit, watch } = methods

  const [unread, from, to] = watch(['unread', 'from', 'to'])
  useEffect(() => {
    onSubmit({ ...filter, unread, from, to })
  }, [unread, from, to])

  return <FormProvider {...methods}>
    <form onSubmit={handleSubmit(onSubmit)}>
      <Flex gap={4} flexDir={{ base: 'column', sm: 'row' }} justifyContent={'space-between'}>
        <Flex gap={2} alignItems={'center'} ml={'auto'}>
          <Switch {...register('unread')}></Switch>
          <FormLabel fontSize={'sm'} fontWeight={'normal'}>Pouze nepřečtené</FormLabel>
        </Flex>
        {/* <Flex gap={2} flexDir={{ base: 'column', sm: 'row' }}>
                        <Flex gap={2} alignItems={'center'}>
                            <FormLabel>od</FormLabel>
                            <ReactHookFormDatepicker name='from' htmlSize={9} />
                        </Flex>
                        <Flex gap={2} alignItems={'center'}>
                            <FormLabel>do</FormLabel>
                            <ReactHookFormDatepicker name='to' htmlSize={9} />
                        </Flex>
                    </Flex> */}
      </Flex>
    </form>
  </FormProvider>
}